// @ts-nocheck

import { playOverlayAnimation } from '../../actions/overlay';
import { BANKROLL_CHANGES_START_ANIM_DELAY } from '../../components/UserBankroll';
import { SpineAnimations } from '../../constants/animations';
import { selectBasketBoomIsActive } from '../../modules/boom/selectors/basket.selector';
import { selectBoomGlobalSkinId } from '../../modules/boom/selectors/global/globalPrimary.selector';
import { selectIsBoomPlayable } from '../../modules/boom/selectors/runtime.selector';
import { BoomSkinIds } from '../../modules/boom/types/global';
import SoundPlayer from '../../singletons/SoundPlayer';
import { BasketActionTypes } from '../../types/actions/basket';
import { UserActionTypes } from '../../types/actions/user';
import { BalanceChangeTypes } from '../../types/balanceChanges';
import { BasketModes } from '../../types/basket';
import { Licences } from '../../types/common';
import { VibrationPatterns } from '../../types/device';
import { SoundIds } from '../../types/sounds';
import { device } from '../../utils';
import { type HandlerProps } from '../synchronousMiddleware';

const klFlutesSounds = Object.freeze([
  SoundIds.KL_FLUTES_1,
  SoundIds.KL_FLUTES_2,
  SoundIds.KL_FLUTES_3,
  SoundIds.KL_FLUTES_4,
  SoundIds.KL_FLUTES_5,
  SoundIds.KL_FLUTES_6,
]);

export const handledActionTypes = [
  '@@APP_INIT',
  BasketActionTypes.SUBMIT_OK,
  BasketActionTypes.SET_NOTIFICATION,
  BasketActionTypes.OUTCOME_SELECTED,
  BasketActionTypes.OUTCOME_UNSELECTED,
  BasketActionTypes.CLEAR,
  BasketActionTypes.SET_ITEM_KL_ELIGIBLE_COLLECTIBLE,
  BasketActionTypes.SET_KL_ELIGIBLE_COLLECTIBLE,
  BasketActionTypes.SET_ITEM_FREEBET_BOOLEAN,
  BasketActionTypes.SET_ITEM_IS_GR_ACTIVE,
  BasketActionTypes.SET_IS_GR_ACTIVE,
  BasketActionTypes.SET_BOOM_IS_ACTIVE,
  BasketActionTypes.SET_ITEM_BOOM_IS_ACTIVE,
  UserActionTypes.SET_BANKROLL,
];

const mobileDevicesMiddlewareHandler = ({ store: { getState, dispatch }, action }: HandlerProps) => {
  const { type: actionType, payload: actionPayload = {} } = action;
  const state = getState();

  if (~handledActionTypes.indexOf(actionType)) {
    if (actionType === '@@APP_INIT') {
      klFlutesSounds.forEach((soundId) => SoundPlayer.load(soundId));
      SoundPlayer.load(SoundIds.BOOM_HALLOWEEN_BASKET);
      SoundPlayer.load(SoundIds.BOOM_START);

      const { runtime } = getState();
      const { licence } = runtime ?? {};

      switch (licence) {
        case Licences.FR:
          SoundPlayer.load(SoundIds.ANTHEM_FR);
          break;
        case Licences.ES:
          SoundPlayer.load(SoundIds.ANTHEM_ES);
          break;
        case Licences.DE:
          SoundPlayer.load(SoundIds.ANTHEM_DE);
          break;
        default:
      }
    }
    if (actionType === BasketActionTypes.SUBMIT_OK) {
      const { body: { ecode } = {} } = actionPayload;

      if (ecode === 0) {
        device.vibrate(VibrationPatterns.NORMAL);

        const { basket, overlay } = getState();

        const isBasketKLEligible = !!basket?.eligibleKLCollectibleId;
        const isBasketItemsKLEligible = !!Object.values(basket?.items ?? {}).filter(
          // $FlowFixMe
          ({ eligibleKLCollectibleId }) => !!eligibleKLCollectibleId,
        ).length;

        if (isBasketKLEligible || isBasketItemsKLEligible) {
          const randomKLFlutesSound = klFlutesSounds[Math.floor(Math.random() * klFlutesSounds.length)];

          SoundPlayer.load(randomKLFlutesSound).then((s) => {
            s.play();
          });
        }

        if (isBasketKLEligible || isBasketItemsKLEligible) {
          const randomKLFlutesSound = klFlutesSounds[Math.floor(Math.random() * klFlutesSounds.length)];

          SoundPlayer.load(randomKLFlutesSound).then((s) => {
            s.play();
          });
        }

        const isBoomPlayable = state ? selectIsBoomPlayable(state) : false;
        const boomSkinId = isBoomPlayable && state ? selectBoomGlobalSkinId(state) : null;
        const isBoomBasketActive = isBoomPlayable && state ? selectBasketBoomIsActive(state) : null;

        if (isBoomBasketActive) {
          if (boomSkinId === BoomSkinIds.HALLOWEEN) {
            SoundPlayer.load(SoundIds.BOOM_HALLOWEEN_BASKET).then((s) => {
              s.play();
            });
          }
        }

        const isBasketSimpleMode = basket?.mode === BasketModes.SIMPLE;
        const nbOfItems = Object.keys(basket?.items).length;
        const isAnimationBasketAllowed = !isBasketSimpleMode || nbOfItems === 1;

        const animationToPlay = action.payload?.body?.p;
        const isAnimationExists = SpineAnimations[animationToPlay];

        const isOverlayAnimationPlaying = !!overlay?.animationId;

        if (isAnimationBasketAllowed && isAnimationExists && !isOverlayAnimationPlaying) {
          dispatch(playOverlayAnimation(animationToPlay));
        }
      }
    }

    if (actionType === BasketActionTypes.SET_NOTIFICATION) {
      const { body: { ecode } = {} } = actionPayload;

      if (ecode === 0) {
        device.vibrate(VibrationPatterns.NORMAL);
      }
    }

    if (
      ~[
        BasketActionTypes.OUTCOME_SELECTED,
        BasketActionTypes.OUTCOME_UNSELECTED,
        BasketActionTypes.CLEAR,
        BasketActionTypes.SET_ITEM_KL_ELIGIBLE_COLLECTIBLE,
        BasketActionTypes.SET_KL_ELIGIBLE_COLLECTIBLE,
        BasketActionTypes.SET_ITEM_FREEBET_BOOLEAN,
        BasketActionTypes.SET_ITEM_IS_GR_ACTIVE,
        BasketActionTypes.SET_IS_GR_ACTIVE,
      ].indexOf(actionType)
    ) {
      device.vibrate(VibrationPatterns.QUICK);
    }

    if (actionType === UserActionTypes.SET_BANKROLL) {
      const { type } = actionPayload;

      if (type === BalanceChangeTypes.CREDIT) {
        setTimeout(() => {
          device.vibrate(VibrationPatterns.BANKROLL_CHANGED);
        }, BANKROLL_CHANGES_START_ANIM_DELAY);
      }
    }
  }
};

export default mobileDevicesMiddlewareHandler;
